module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hto2oN/media/FC-9781035812745.jpg?1708094060589",
      "alt": "This image is the cover for the book Grief Is a Love Language"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Grief Is a Love Language\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Grief Is a Love Language is a collection of poetry that behaves like a novel, telling the story of a young woman dealing with the earth-shattering pain of loss and the painstaking healing process of recreating yourself in the wake of it. It shows us everything we learn from grief when we allow it to teach us, exploring love, mental health, family, self-love, and trauma along the way. It does all of this with unflinching honesty, through the lens of incredibly vivid and mesmerizing imagery. No emotion goes unexplored here, and each is masterfully expressed.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Noha Medhat\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Once a journalist and a creative in marketing and now a creative in advertising, Noha Medhat loves exploring writing and the creative process through different mass media. However, poetry has remained her first love and passion. Writing poems since she was 13, she has always been fascinated by the magic of translating feelings into words. Grief Is a Love Language is her first book and poetry collection. She lives in Cairo, Egypt.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0